'use client';
import React, { useState, useEffect } from 'react';
import Button from '../ui/Button';
import BASE_URL from '../constants';
import Link from 'next/link';
import useCustomSWR from '@/hook/useCustomSWR';
import { v4 as uuidv4 } from 'uuid';
const Category = () => {
  const [activeButtonIndex, setActiveButtonIndex] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null); // Define selectedCategory state

  const { data, isLoading, isError, revalidate } = useCustomSWR(
    `/v1/categories/get/menu?page=1&limit=500`,
    true
  );
  const categories = data?.parentCategories || [];
  const initialSelectedCategory = data?.parentCategories[0] || null; // Set initial selected category

  useEffect(() => {
    window.scrollTo(0, 0);
    setSelectedCategory(initialSelectedCategory); // Set initial selected category on mount
  }, [initialSelectedCategory]); // Add initialSelectedCategory to dependency array

  const handleCategoryChange = (category, index) => {
    setSelectedCategory(category);
    setActiveButtonIndex(index);
  };
  return (
    <div className='border-t-1 relative rounded-md border-gray-300 px-4 py-8 sm:px-8 md:px-16'>
      <div className='relative'>
        <div className='flex flex-wrap items-center justify-center gap-2 sm:gap-4'>
          {categories.map((category, index) => (
            <Button
              key={uuidv4()}
              onClick={() => handleCategoryChange(category, index)}
              className={`mb-2 ${activeButtonIndex === index ? 'bg-black text-white' : ''
                }`}
            >
              {category.category_name}
            </Button>
          ))}
        </div>
      </div>

      <h1 className='text-base md:text-xl font-bold text-center p-4'>Explore Our Diverse Categories of Innovative Products</h1>
      <div className='relative mt-2 text-center'>
        {selectedCategory && (
          <>
            <h2 className='text-lg font-semibold uppercase'>
              <Link href={`/${selectedCategory.category_slug}`}>{selectedCategory.category_name}</Link>
            </h2>
            <p className='text-xs text-gray-600'>
              {selectedCategory.category_desc}
            </p>
            {selectedCategory.subCategories && (
              <div>
                <ul className='text-sm text-gray-600'>
                  {selectedCategory.subCategories.map((subCategory) => (
                    <div key={uuidv4()} className='my-4'>
                      <h2 className='py-2 text-base font-medium capitalize'>
                        <a href={subCategory.subCategoriesPath} >{subCategory.category_name}</a>
                      </h2>
                      <div className='flex justify-center items-center flex-wrap gap-5'>
                        {subCategory.childCategories.map((childCategory) => (
                          <div
                            key={uuidv4()}
                            className='basis-[45%] sm:basis-52 flex flex-col items-center gap-2 py-4 '
                          >
                            <Link
                              href={`${childCategory.childCategoriesPath}`}
                            >
                              {childCategory?.category_img && (
                                <img
                                  className='h-24 w-48 rounded-lg border'
                                  src={childCategory?.category_img}
                                  alt={childCategory?.category_name}
                                />
                              )}
                              <p className='text-xs p-1 font-medium'>
                                {childCategory?.category_name}
                              </p>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </ul>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Category;
